import { useContext } from 'react';

import MediaContext from './MediaContext';

const useMedia = () => {
  const context = useContext(MediaContext);
  if (context === null) {
    throw new Error('useMedia must be used within a MediaProvider');
  }
  return context;
};

export default useMedia;
